import React from 'react';
import { StoryboardPDFTemplate } from './StoryboardPDFTemplate';
import { StoryboardFrame } from '@/features/storyboard/types/storyboard.types';
import { Shot } from '@/features/shotlist';
import { PdfService } from '@/shared/services/pdf.service';

export const downloadStoryboardPDF = async (
    fileName: string,
    projectTitle: string,
    sceneTitle: string | undefined,
    frames: StoryboardFrame[],
    shots: Shot[]
) => {
    if (typeof window === 'undefined') return;

    try {
        // Pre-fetch all frame images into base64 to prevent React-PDF network loading issues
        const base64Images: Record<string, string> = {};
        
        await Promise.all(
            frames.map(async (frame) => {
                try {
                    if (frame.imageUrl) {
                        base64Images[frame.id] = await PdfService.getBase64ImageFromUrl(frame.imageUrl);
                    }
                } catch (imgError) {
                    console.warn(`Failed to process image for frame ${frame.id}:`, imgError);
                }
            })
        );

        // Fetch brand logo
        const brandLogoBase64 = await PdfService.fetchBrandLogoBase64();

        const documentElement = (
            <StoryboardPDFTemplate
                projectTitle={projectTitle}
                sceneTitle={sceneTitle}
                frames={frames}
                shots={shots}
                base64Images={base64Images}
                brandLogoBase64={brandLogoBase64}
            />
        );

        // Dispatch entirely to shared PdfService
        await PdfService.downloadReactPdfDocument(documentElement, fileName);
    } catch (error) {
        console.error('Error generating React-PDF Storyboard:', error);
        throw error;
    }
};
